import React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { AppContext } from "App";

import { bridge } from "@multiweb/reactCore/bridge";
import { createRootComponent, StoreManager } from "@multiweb/reactSetup";
import { IDisposable } from "Global/Base/IDisposable";
import { createClearPicassoHostAction, createInitPicassoHostAction, WorkflowEditor, WorkflowEditorMode } from "../UI.React/workflowEditor";
import { Workflow } from "../UI.React/workflowEditor/workflowModel";

const { dispatchAction } = bridge;

export class WorkflowEditorConnector implements IDisposable {
    private readonly _hostKey: string;
    private readonly _rootElement: HTMLElement;

    constructor(
        hostKey: string,
        element: HTMLElement,
        workflow: Workflow,
        saveWorkflow: () => Promise<boolean>,
        reloadWorkflow: () => Promise<string>,
        setIsWfEdited: (isEdited: boolean) => Promise<void>,
        wfEditorMode: WorkflowEditorMode,
        wfStatusXml?: string,
    ) {
        this._hostKey = hostKey;
        this._rootElement = element;
        const isDev = !!AppContext.instance.configuration.developmentMode;
        StoreManager.initializeStore(isDev);
        const RootComponent = createRootComponent(isDev);

        dispatchAction(createInitPicassoHostAction(hostKey));

        render(
            <RootComponent>
                <WorkflowEditor {...{ hostKey, wfEditorMode, workflow, wfStatusXml, saveWorkflow, reloadWorkflow, setIsWfEdited }} />
            </RootComponent>,
            this._rootElement,
        );
    }

    public dispose(): void {
        unmountComponentAtNode(this._rootElement);
        dispatchAction(createClearPicassoHostAction(this._hostKey));
    }
}
